package com.karawek.core.ui.designcatalog.sections

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Settings
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.karawek.core.ui.components.CoreCheckbox
import com.karawek.core.ui.components.CoreIconButton
import com.karawek.core.ui.components.CorePrimaryButton
import com.karawek.core.ui.components.CoreSecondaryButton
import com.karawek.core.ui.components.CoreTextField
import com.karawek.core.ui.components.CoreToggle
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogComponents() {
    Column(verticalArrangement = Arrangement.spacedBy(CoreSpacing.lg)) {

        SectionHeader("Buttons")

        CorePrimaryButton(
            text = "Primary",
            onClick = {},
        )

        CorePrimaryButton(
            text = "Primary Disabled",
            enabled = false,
            onClick = {},
        )

        CoreSecondaryButton(
            text = "Secondary",
            onClick = {},
        )

        CoreSecondaryButton(
            text = "Secondary Disabled",
            enabled = false,
            onClick = {},
        )

        CoreIconButton(
            icon = Icons.Outlined.Settings,
            contentDescription = "Settings",
            onClick = {},
        )

        CoreIconButton(
            icon = Icons.Outlined.Settings,
            contentDescription = "Settings",
            enabled = false,
            onClick = {},
        )

        SectionHeader("Checkbox")

        var checked by remember { mutableStateOf(false) }

        CoreCheckbox(
            checked = checked,
            onCheckedChange = { checked = it },
        )

        CoreCheckbox(
            checked = true,
            onCheckedChange = {},
            enabled = false,
        )

        SectionHeader("Toggles")

        var toggleChecked by remember { mutableStateOf(true) }

        CoreToggle(
            checked = toggleChecked,
            onCheckedChange = { toggleChecked = it },
        )

        CoreToggle(
            checked = false,
            enabled = false,
            onCheckedChange = {},
        )

        SectionHeader("Text Inputs")

        CoreTextField(
            value = "Hello",
            label = "Default",
            onValueChange = {},
        )

        CoreTextField(
            value = "",
            label = "Error",
            error = "Something went wrong",
            onValueChange = {},
        )

        CoreTextField(
            value = "Disabled",
            label = "Disabled",
            enabled = false,
            onValueChange = {},
        )
    }
}

@Composable
private fun SectionHeader(title: String) {
    Text(
        text = title,
        style = CoreTypography.title,
    )
}
